export default "__VITE_ASSET__12dbbe59__"